import React, { cloneElement, useEffect, useState } from "react";
import { List, CreateButton, RefreshButton, TopToolbar, Datagrid, TextField, DateField, ShowButton, Filter, TextInput, SelectInput,useRecordContext } from 'react-admin';
// import { DateInput } from 'react-admin-date-inputs';
import { Scrollbars } from 'react-custom-scrollbars';
import Spinner from '../spinner';
import myDataProvider from '../myRestProvider';
import { unparse as convertToCSV } from 'papaparse/papaparse.min';
import Modal from 'react-responsive-modal';

const selectInputStyle = {
    width: 200,
};

const InAppFilter = (props) => (
    <Filter {...props}>
        <TextInput source="purpose" />
        <TextInput source="admin_email" />
        <TextInput source="admin_name" />
        <SelectInput source="job_status" choices={[
            { id: 'Complete', name: 'Complete' },
            { id: 'Queued', name: 'Queued' },
            { id: 'Working', name: 'Working' },
        ]}
        />
        {/* <DateInput source="from_date"  label="Uploaded date from"  />
        <DateInput source="to_date"  label="Uploaded date to"  /> */}
    </Filter>
);

// const topToolbarStyle = {
//     zIndex: 2,
//     display: 'inline-block',
//     float: 'right',
// };

const textFieldStyle = {
    display: 'block',
    width: 200,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',

};

const ListActions = ({ resource, basePath, filterValues, total, maxResults, currentSort, exporter, permanentFilter, showFilter, displayedFilters, filters }) => {
    return (
        <TopToolbar>
            {filters && cloneElement(filters, {
                resource,
                showFilter,
                displayedFilters,
                filterValues,
                context: 'button',
            })}
            <CreateButton basePath={basePath} />
            <RefreshButton />
        </TopToolbar>
    )
}

const BulkInAppNotificationList = (props) => {
    // state = {
    //     modalShow: false,
    // }
    const [modalShow, setModalShow] = useState(false);
    const [modalMsg, setModalMsg] = useState('');

    const exporter = (data) => {
        const msg = data[0].message;
        setModalShow(true);
        setModalMsg(msg)
    }

    const onClose = () => {
        setModalShow(false);
    }

    const ProgressField = ({ source }) => {
        const record = useRecordContext();
        return (
            <span>{record[source] === '-' ? '-' : (record[source] ? record[source] : '-')}</span>
        )
    }

    const NameField = ({ source }) => {
        const record = useRecordContext();
        return (
            <span>{record[source] === '-' ? '-' : (record[source] ? record[source] : '-')}</span>
        )
    }


    // const { state, props, permissions } = this;
    return (
        <React.Fragment>
            <Scrollbars className="scroll-container" >
                <List {...props} exporter={(data) => exporter(data)} sort={{ field: 'created_at', order: 'DESC' }} filters={<InAppFilter />} title="Notification" actions={<ListActions />}>
                    <Datagrid rowClick="show" bulkActionButtons={false}>
                        <TextField source="purpose" style={textFieldStyle} allowEmpty />
                        <ProgressField source="job_status" />
                        <NameField source="admin_name" />
                        <TextField source="admin_email" />
                        {/* <DateField label={'Created at'} source="created_at" allowEmpty /> */}
                        <DateField source="created_at" showTime />
                        <ShowButton />
                    </Datagrid>
                </List>
            </Scrollbars>
            {
                modalShow &&
                <Modal open={modalShow} onClose={onClose} center>
                    <h3>{modalMsg}</h3>
                </Modal>
            }
        </React.Fragment>
    )

}

export default BulkInAppNotificationList;